import styled from "styled-components";
import { Row } from "../../styles-components/FormItens";

export const RowSearching = styled(Row)`
  span {
    color: #086BAB;
    margin-left: 5px;
  }

  @media (max-width: 760px) {
    align-items: center;
    flex-direction: column-reverse;
  }
`;
